var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"no-connection red white--text",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.$t('noConnection'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }